import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Files from './components/Files';

const files = (props,{ t }) => (
  <Container>
    <Files {...props} />
  </Container>
);

files.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(files);
